import { EventForm } from '@/components/events/EventForm';
import { type EventFormValues } from '@/lib/schemas/event';
import axiosInstance from '@/lib/axios';
import { toast } from 'sonner';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle as CardHeaderTitle,
} from '@/components/ui/card';
import { useState } from 'react';
import { EventsPageShell } from './components/EventsPageShell';

export default function CreateEventPage() {
  const navigate = useNavigate();
  const { communityId } = useParams<{ communityId: string }>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function onSubmit(values: EventFormValues) {
    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post('/api/events', values);
      toast.success('Event created successfully');
      navigate(`/${communityId}/events/${response.data.slug || response.data.id}`);
    } catch (error) {
      console.error(error);
      toast.error('Failed to create event');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <EventsPageShell>
      <Card className="w-full animate-in slide-in-from-bottom-5 border-0 bg-background/50 shadow-none backdrop-blur-md duration-300 md:border md:border-border md:shadow-2xl">
        <CardHeader className="px-3 md:px-6">
          <CardHeaderTitle className="text-2xl font-black tracking-tight text-foreground">
            Create New Event
          </CardHeaderTitle>
          <CardDescription className="text-muted-foreground">
            Fill in the details to host a new event.
          </CardDescription>
        </CardHeader>
        <CardContent className="px-3 md:px-6">
          <EventForm
            initialValues={{ communityId: communityId || '' }}
            onSubmit={onSubmit}
            submitButtonText="Create Event"
            isSubmitting={isSubmitting}
            requireAddress
            onCancel={() => navigate(-1)}
          />
        </CardContent>
      </Card>
    </EventsPageShell>
  );
}
